import { useCallback, useState } from 'react';
import { useQuery } from 'react-query';
import { Dayjs } from 'dayjs';
import { DateFormat } from '@shared/constants';
import { CashFlowAnalyticsService } from '../../services';
import { ICashFlowAnalyticsResult } from '../../interfaces';

export const useCashFlowAnalytics = () => {
  const [cashRegisterId, setCashRegisterId] = useState<number | undefined>();
  const [date, setDate] = useState<[Dayjs, Dayjs] | null>(null);

  const startDate = date ? date[0].format(DateFormat.DATE_TIME) : '';
  const endDate = date ? date[1].format(DateFormat.DATE_TIME) : '';

  const result = useQuery<ICashFlowAnalyticsResult, Error>(
    ['cash-flow-analytics', cashRegisterId, startDate, endDate],
    async () => {
      if (!cashRegisterId) throw new Error('Kassa seçin...');
      if (!startDate || !endDate) throw new Error('Tarix seçin...');
      const response = await CashFlowAnalyticsService.getAnalytics({ cashbox_id: cashRegisterId, start_date: startDate, end_date: endDate });
      if (response.status === 200) return response.data;
      throw new Error(response.data as string);
    },
    { enabled: !!cashRegisterId && !!startDate && !!endDate, retry: false },
  );

  const onCashRegisterIdChange = useCallback((value: number) => setCashRegisterId(value), []);
  const onDateChange = useCallback((value: [Dayjs, Dayjs] | null) => setDate(value), []);

  return { result, filters: { cashRegisterId, date }, onCashRegisterIdChange, onDateChange };
};
